import { useSyncExternalStore } from "react";

// Та же граница, что у бокового меню: уже — телефон, описание предмета — шторкой снизу.
const NARROW_QUERY = "(max-width: 47.999rem)";

const subscribe = (onChange: () => void) => {
  if (typeof window.matchMedia !== "function") {
    return () => undefined;
  }
  const query = window.matchMedia(NARROW_QUERY);
  query.addEventListener("change", onChange);
  return () => {
    query.removeEventListener("change", onChange);
  };
};

const isNarrow = () =>
  typeof window.matchMedia === "function" && window.matchMedia(NARROW_QUERY).matches;

// Узкий экран (телефон): следит за шириной окна.
export const useNarrowScreen = () => useSyncExternalStore(subscribe, isNarrow, () => false);
